<!-- 状态面板 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">样式设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <!-- 内容设置 -->
                <div v-if="name_id == 1">
                    <!-- 状态面板列表：数据由 template_diy_state_list 接口回显，
                         每一项是独立的状态面板，可单独编辑、保存、删除 -->
                    <div class="form-title">状态面板</div>
                    <div class="status-list-box">
                        <div
                            class="status-item"
                            v-for="(item, index) in newFormData.content
                                .statusList"
                            :key="index"
                        >
                            <div class="item-actions">
                                <span
                                    class="action-link"
                                    @click="moveStatus(index, -1)"
                                    >上移</span
                                >
                                <span
                                    class="action-link"
                                    @click="moveStatus(index, 1)"
                                    >下移</span
                                >
                                <span
                                    class="action-link"
                                    @click="openStatusEdit(index)"
                                    >编辑</span
                                >
                                <div class="del-btn" @click="delStatus(index)">
                                    <Icon type="ios-trash" color="#fff" />
                                </div>
                            </div>
                            <Form :label-width="110" label-position="left">
                                <FormItem label="状态标题">
                                    <div>{{ item.title }}</div>
                                </FormItem>
                                <FormItem label="当前状态">
                                    {{ item.current_status }}
                                </FormItem>
                                <FormItem label="更新权限">
                                    <span>{{
                                        permissionText(item.who_type)
                                    }}</span>
                                    <span
                                        class="action-link ml12"
                                        @click="openPermission(index)"
                                        >修改</span
                                    >
                                </FormItem>
                                <FormItem label="自动变更规则">
                                    <span>{{ getRulesCount(item) }} 条</span>
                                    <span
                                        class="action-link ml12"
                                        @click="openRules(index)"
                                        >修改</span
                                    >
                                </FormItem>
                            </Form>
                        </div>
                        <div class="add-status" @click="addStatus">
                            <Icon type="md-add" size="20" color="#FF761D" />
                            <span>添加状态项</span>
                        </div>
                    </div>
                </div>

                <!-- 样式设置 -->
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="form-title">选择样式</div>
                        <div class="style-select">
                            <div class="section-label">样式一</div>
                            <div
                                :class="
                                    newFormData.content.style_value == '1'
                                        ? 'style-card style-card-active'
                                        : 'style-card'
                                "
                                @click="changeStyle('1')"
                            >
                                <img src="@/assets/statusPanel-1.png" class="w1" />
                            </div>
                            <div class="section-label mt12">样式二</div>
                            <div
                                :class="
                                    newFormData.content.style_value == '2'
                                        ? 'style-card style-card-active'
                                        : 'style-card'
                                "
                                @click="changeStyle('2')"
                            >
                                <img src="@/assets/statusPanel-2.png" class="w1" />
                            </div>
                        </div>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openPicModal">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>

                <!-- 边距设置 -->
                <div v-if="name_id == 3">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>

        <!-- 编辑状态项弹窗 -->
        <Modal
            v-model="statusModal"
            title="状态"
            :width="640"
            :mask-closable="false"
        >
            <div class="modal-row mb16">
                <span class="modal-label">
                    状态
                    <Icon type="md-create" />
                </span>
                <Input
                    class="w300"
                    v-model="editTitle"
                    placeholder="请输入状态名"
                />
            </div>
            <div class="section-label mb12">状态项</div>
            <div class="opt-row" v-for="(opt, oi) in editOptions" :key="oi">
                <Input
                    class="w120"
                    v-model="opt.name"
                    placeholder="请输入状态名"
                />
                <ColorPicker
                    class="ml12"
                    v-model="opt.color"
                    :colors="presetColors"
                />
                <Checkbox
                    class="ml12"
                    :true-value="1"
                    :false-value="0"
                    v-model="opt.is_default"
                    @on-change="(v) => setDefaultOption(oi, v)"
                    >默认状态</Checkbox
                >
                <span class="opt-req">{{ requireText(opt) }}</span>
                <span class="action-link ml8" @click="openRequire(oi)"
                    >修改</span
                >
                <Icon
                    class="ml8 cursor-p"
                    type="ios-close-circle"
                    color="#ed4014"
                    size="20"
                    @click="delOption(oi)"
                />
            </div>
            <div class="add-status mt12" @click="addOption">
                <Icon type="md-add" size="18" color="#FF761D" />
                <span>添加状态项</span>
            </div>
            <div slot="footer">
                <Button @click="statusModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveStatusEdit"
                    >保存</Button
                >
            </div>
        </Modal>

        <!-- 设置切换要求 -->
        <Modal
            v-model="requireModal"
            title="设置切换要求"
            :width="520"
            :mask-closable="false"
        >
            <div class="mb16">
                设置切换到「{{
                    (editOptions[requireIndex] &&
                        editOptions[requireIndex].name) ||
                    ""
                }}」时的要求
            </div>
            <RadioGroup v-model="requireForm.switch_type" vertical>
                <Radio :label="0" class="mb12">无任何要求</Radio>
                <Radio :label="1">需填写描述信息</Radio>
            </RadioGroup>
            <div class="require-box" v-if="requireForm.switch_type == 1">
                <div class="mb12 flex-box">
                    <div class="mr24">支持类型</div>
                    <CheckboxGroup v-model="requireForm.switch_support_types">
                        <Checkbox :label="1">文字描述</Checkbox>
                        <Checkbox :label="2">图片</Checkbox>
                        <Checkbox :label="3">定位</Checkbox>
                    </CheckboxGroup>
                </div>
                <div class="flex-box">
                    <div class="mr24">是否必填</div>
                    <RadioGroup v-model="requireForm.switch_is_required">
                        <Radio :label="1">必填</Radio>
                        <Radio :label="0">不必填</Radio>
                    </RadioGroup>
                </div>
            </div>
            <div slot="footer">
                <Button @click="requireModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveRequire"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 更新权限 -->
        <Modal
            v-model="permissionModal"
            title="更新权限"
            :width="560"
            :mask-closable="false"
        >
            <RadioGroup v-model="permissionForm.who_type" vertical>
                <Radio label="0" class="mb8">所有人</Radio>
                <div class="perm-tip">
                    公开后表单记录所有人可见，请确保合法合规
                </div>
                <Radio label="1" class="mt12 mb8">全部成员</Radio>
                <Radio label="2">指定成员</Radio>
            </RadioGroup>
            <div class="require-box" v-if="permissionForm.who_type == '2'">
                <Select
                    class="mt12 w240"
                    v-model="permissionForm.customer_ids"
                    multiple
                    filterable
                    placeholder="选择人员"
                >
                    <Option
                        v-for="m in memberOptions"
                        :value="m.id"
                        :key="m.id"
                        :label="m.name"
                    />
                </Select>
            </div>
            <div slot="footer">
                <Button @click="permissionModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="savePermission"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 自动变更规则 -->
        <Modal
            v-model="rulesModal"
            title="自动变更规则"
            :width="640"
            :mask-closable="false"
        >
            <div v-if="!editRules.length" class="rules-empty">
                <div class="empty-tip">该状态暂无规则</div>
                <div class="empty-desc">
                    如果你需要一线人员在码上填写表单，可以设置当某条表单数据提交时或者提交的数据满足特定条件时，二维码的状态自动变更。无需一线人员填完表单后再去手动更新状态
                </div>
                <Button
                    class="theme-bc theme-default-color empty-add-btn"
                    @click="openRuleForm(-1)"
                >
                    <Icon type="md-add" size="16" />
                    新增规则
                </Button>
            </div>
            <div v-else class="rules-list">
                <div
                    class="rule-item"
                    v-for="(rule, ri) in editRules"
                    :key="ri"
                >
                    <div class="rule-text">
                        当【{{ formName(rule) }}】表单任意数据提交时，二维码上的「{{
                            currentItemTitle
                        }}」变更为「{{ targetStatusName(rule) }}」
                    </div>
                    <div class="rule-actions">
                        <span class="action-link" @click="openRuleForm(ri)"
                            >修改</span
                        >
                        <span class="action-link ml12" @click="delRule(ri)"
                            >删除</span
                        >
                    </div>
                </div>
            </div>
            <Button
                v-if="editRules.length"
                long
                class="theme-bc theme-default-color mt16"
                @click="openRuleForm(-1)"
                >+ 新增规则</Button
            >
            <div slot="footer">
                <Button @click="rulesModal = false">取消</Button>
                <Button class="theme-bc theme-default-color" @click="saveRules"
                    >保存</Button
                >
            </div>
        </Modal>

        <!-- 新增/修改规则 -->
        <Modal
            v-model="ruleFormModal"
            title="新增规则"
            :width="520"
            :mask-closable="false"
        >
            <Form :label-width="140" label-position="left">
                <FormItem label="当码上的表单">
                    <Select
                        v-model="ruleForm.form_id"
                        filterable
                        placeholder="请选择表单"
                        @on-change="onFormChange"
                    >
                        <Option
                            v-for="f in formOptions"
                            :value="f.id"
                            :key="f.id"
                            >{{ f.name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="提交的数据类型为">
                    <Input value="任意数据提交时" disabled />
                </FormItem>
                <FormItem label="二维码状态变更为">
                    <Select
                        v-model="ruleForm.target_state_key"
                        filterable
                        placeholder="请选择状态项"
                    >
                        <Option
                            v-for="(opt, oi) in currentStatusOptions"
                            :value="opt.state_key"
                            :key="oi"
                            >{{ opt.name }}</Option
                        >
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="ruleFormModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveRuleForm"
                    >确定</Button
                >
            </div>
        </Modal>

        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
// 状态面板相关接口：
//   template_diy_form_list        —— 获取表单列表（用于「当码上的表单」下拉）
//   template_diy_state_list       —— 获取状态面板列表（回显，含状态值、规则）
//   template_diy_state_save       —— 保存状态面板基本信息（标题/权限/排序，不含状态值、规则）
//   template_diy_state_del        —— 删除整个状态面板
//   template_diy_state_sort       —— 上移/下移排序
//   template_diy_state_item_save  —— 保存单个状态值（新增/编辑）
//   template_diy_state_item_del   —— 删除单个状态值
//   template_diy_rule_save        —— 保存单个变幻规则（新增/编辑）
//   template_diy_rule_del         —— 删除单个变幻规则
import {
    template_diy_form_list,
    template_diy_state_list,
    template_diy_state_save,
    template_diy_state_del,
    template_diy_state_sort,
    template_diy_state_item_save,
    template_diy_state_item_del,
    template_diy_rule_save,
    template_diy_rule_del,
} from "@/api/diyForm";
import { customer_select } from "@/api/index";

// 根据状态值名称返回默认展示颜色（后端未返回 color 时兜底）
function getDefaultStatusColor(name) {
    if (name === "正常") return "#52C41A";
    if (name === "异常") return "#F5222D";
    if (name === "待处理") return "#FF761D";
    if (name === "已完成") return "#1890FF";
    return "#FF761D";
}

// 规范化规则数据：统一为前端使用的字段结构
function normalizeRules(rules) {
    if (!rules) return [];
    const list = Array.isArray(rules) ? rules : [];
    return list.map((rule) => ({
        id: rule.id || 0,
        form_id: rule.form_id || 0,
        form_name: rule.form_name || "",
        target_state_id: rule.target_state_id || 0,
        target_state_key: rule.target_state_key || "",
    }));
}

// 归一化支持类型：后端可能返回字符串数组 ["1","2","3"]，统一转为数字数组 [1,2,3]
function normalizeSupportTypes(types) {
    if (!Array.isArray(types)) return [1, 2, 3];
    return types.map((t) => Number(t)).filter((n) => n >= 1 && n <= 3);
}

// 生成状态值临时标识（同一面板内唯一），供规则 target_state_key 引用
function generateStateKey() {
    return (
        "state_" +
        Date.now().toString(36) +
        "_" +
        Math.random().toString(36).slice(2, 8)
    );
}

// 创建默认状态值列表（正常 / 异常），字段值使用后端约定的数字枚举
function createDefaultOptions() {
    return [
        {
            id: 0,
            state_key: generateStateKey(),
            name: "正常",
            color: "#52C41A",
            is_default: 1,
            switch_type: 0,
            switch_support_types: [1, 2, 3],
            switch_is_required: 1,
            sort: 0,
        },
        {
            id: 0,
            state_key: generateStateKey(),
            name: "异常",
            color: "#F5222D",
            is_default: 0,
            switch_type: 0,
            switch_support_types: [1, 2, 3],
            switch_is_required: 1,
            sort: 1,
        },
    ];
}

// 创建一个默认状态面板项（含默认状态值和默认权限）
function createStatusItem() {
    const options = createDefaultOptions();
    return {
        id: 0,
        title: "状态",
        current_status: "正常",
        statusOptions: options,
        who_type: 0,
        customer_ids: [],
        rules: [],
    };
}

export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
        content_id: {
            type: [String, Number],
            default: "",
        },
        pageFormData: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            presetColors: [
                "#52C41A",
                "#F5222D",
                "#FF761D",
                "#1890FF",
                "#FAAD14",
                "#722ED1",
                "#13C2C2",
                "#EB2F96",
            ],
            memberOptions: [],
            formOptions: [],
            // 编辑状态
            statusModal: false,
            editIndex: -1,
            editTitle: "",
            editOptions: [],
            // 切换要求
            requireModal: false,
            requireIndex: -1,
            requireForm: {
                switch_type: 0,
                switch_support_types: [],
                switch_is_required: 1,
            },
            // 权限
            permissionModal: false,
            permissionForm: {
                who_type: "0",
                customer_ids: [],
            },
            // 规则
            rulesModal: false,
            editRules: [],
            ruleFormModal: false,
            ruleEditIndex: -1,
            ruleForm: {
                form_id: "",
                form_name: "",
                target_state_key: "",
            },
            admin_id: "",
            formListLoading: false,
        };
    },
    created() {
        try {
            this.admin_id = localStorage.getItem("admin_id") || "";
        } catch (e) {
            this.admin_id = "";
        }
        this.ensureComponentKey();
        this.ensureStatusList();
        this.getMemberList();
        this.loadStatusList();
    },
    computed: {
        currentItemTitle() {
            const list = this.newFormData.content.statusList || [];
            const item = list[this.editIndex];
            return (item && item.title) || "状态标题";
        },
        currentStatusOptions() {
            const list = this.newFormData.content.statusList || [];
            const item = list[this.editIndex];
            return (item && item.statusOptions) || [];
        },
    },
    methods: {
        selectName(name) {
            this.name_id = name;
        },
        changeStyle(val) {
            this.newFormData.content.style_value = val;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        openPicModal() {
            this.switch_modal = true;
        },
        getMemberList() {
            customer_select()
                .then((res) => {
                    this.memberOptions = res.data || [];
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "获取人员列表失败");
                });
        },
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        // 确保 statusList 存在且至少有一个状态面板项。
        // 真实数据由 loadStatusList 通过 template_diy_state_list 接口回显，
        // 这里仅在初始无数据时提供一个可编辑的默认项。
        ensureStatusList() {
            const content = this.newFormData.content;
            if (!Array.isArray(content.statusList)) {
                this.$set(content, "statusList", [createStatusItem()]);
            } else if (!content.statusList.length) {
                content.statusList.push(createStatusItem());
            }
        },
        ensureComponentKey() {
            if (!this.newFormData.key) {
                this.$set(
                    this.newFormData,
                    "key",
                    this.admin_id + "a" + Date.now()
                );
            }
        },
        // 通过 template_diy_state_list 接口回显状态面板列表，覆盖 content.statusList
        async loadStatusList() {
            this.ensureComponentKey();
            this.ensureStatusList();
            if (!this.content_id || !this.newFormData.key) {
                return;
            }
            try {
                const res = await template_diy_state_list({
                    diy_template_content_id: Number(this.content_id),
                    component_key: this.newFormData.key,
                });
                const rawList = (res.data && res.data.list) || res.data || [];
                if (Array.isArray(rawList) && rawList.length) {
                    const list = rawList
                        .slice()
                        .sort((a, b) => {
                            const sortA = a.sort != null ? Number(a.sort) : 0;
                            const sortB = b.sort != null ? Number(b.sort) : 0;
                            return sortA - sortB;
                        })
                        .map((form) => this.mapFormToStatusItem(form));
                    this.$set(this.newFormData.content, "statusList", list);
                }
            } catch (err) {
                this.$Message.error(err.msg || "获取状态面板列表失败");
            }
        },
        // 取默认状态值名称（is_default == 1 优先，否则取第一个）
        getDefaultStatusName(statusOptions) {
            const def = (statusOptions || []).find((o) => o.is_default == 1);
            if (def) return def.name;
            return (
                (statusOptions && statusOptions[0] && statusOptions[0].name) ||
                "正常"
            );
        },
        // 后端 state 数据 -> 前端 statusItem（states/rules/who_type 映射回前端结构）
        mapFormToStatusItem(form) {
            const rawStates = Array.isArray(form.states) ? form.states : [];
            const statusOptions = (
                rawStates.length ? rawStates : createDefaultOptions()
            ).map((opt) => ({
                id: opt.id || 0,
                state_key: opt.state_key || generateStateKey(),
                name: opt.name || "正常",
                color: opt.color || getDefaultStatusColor(opt.name),
                is_default: opt.is_default == null ? 0 : Number(opt.is_default),
                switch_type: opt.switch_type == null ? 0 : Number(opt.switch_type),
                switch_support_types: normalizeSupportTypes(
                    opt.switch_support_types
                ),
                switch_is_required:
                    opt.switch_is_required == null
                        ? 1
                        : Number(opt.switch_is_required),
                sort: opt.sort || 0,
            }));
            return {
                id: form.id || 0,
                title: form.title || "状态",
                current_status: this.getDefaultStatusName(statusOptions),
                statusOptions,
                who_type: form.who_type != null ? Number(form.who_type) : 1,
                customer_ids: Array.isArray(form.customer_ids)
                    ? form.customer_ids
                    : [],
                rules: normalizeRules(form.rules),
                sort: form.sort || 0,
            };
        },
        // 构建状态面板基本信息保存参数（state_save 不再接收 states/rules，
        // 状态值、规则分别通过 state_item_save / rule_save 单独保存）
        buildPanelParams(item, index) {
            return {
                diy_template_content_id: Number(this.content_id) || 0,
                component_key: this.newFormData.key,
                id: item.id || 0,
                title: item.title,
                who_type: item.who_type != null ? Number(item.who_type) : 1,
                customer_ids: Array.isArray(item.customer_ids)
                    ? item.customer_ids
                    : [],
                sort: index,
            };
        },
        // 单个状态面板项调排序接口（后端只接收被移动的那一项）
        sortStatusItem(item, sort) {
            if (!this.content_id || !this.newFormData.key) return;
            if (!item || !item.id) return;
            template_diy_state_sort({
                id: item.id,
                sort,
                diy_template_content_id: Number(this.content_id),
                component_key: this.newFormData.key,
            }).catch((err) => {
                this.$Message.error(err.msg || "排序保存失败");
            });
        },
        // 从 startIndex 开始重排（删除后，后续项整体前移一位）
        updateStatusSort(startIndex = 0) {
            const list = this.newFormData.content.statusList || [];
            for (let i = startIndex; i < list.length; i++) {
                const item = list[i];
                item.sort = i;
                this.sortStatusItem(item, i);
            }
        },
        // 将 form_list 返回的数据映射为下拉选项（id + 名称）
        mapFormOptionsFromList(rawList) {
            if (!Array.isArray(rawList)) return [];
            return rawList
                .slice()
                .sort((a, b) => {
                    const sortA = a.sort != null ? Number(a.sort) : 0;
                    const sortB = b.sort != null ? Number(b.sort) : 0;
                    if (sortA !== sortB) return sortA - sortB;
                    return (a.id || 0) - (b.id || 0);
                })
                .map((item) => ({
                    id: item.id,
                    name: item.title || item.btn_title || "未命名表单",
                }));
        },
        // 新增/编辑规则时拉取「当码上的表单」下拉数据（调用 template_diy_form_list 接口）
        async loadFormOptions() {
            this.ensureComponentKey();
            if (!this.content_id || !this.newFormData.key) {
                this.formOptions = [];
                this.$Message.warning("缺少页面ID或组件key，无法获取表单列表");
                return;
            }
            this.formListLoading = true;
            try {
                const res = await template_diy_form_list({
                    diy_template_content_id: Number(this.content_id),
                });
                const rawList = (res.data && res.data.list) || res.data || [];
                this.formOptions = this.mapFormOptionsFromList(rawList);
            } catch (err) {
                this.formOptions = [];
                this.$Message.error(err.msg || "获取表单列表失败");
            } finally {
                this.formListLoading = false;
            }
        },
        // 新增一个状态面板项：先保存面板拿到 id，再保存默认状态值（正常/异常）
        async addStatus() {
            this.ensureStatusList();
            const list = this.newFormData.content.statusList;
            const item = createStatusItem();
            item.sort = list.length;
            const index = list.length;
            list.push(item);
            try {
                // 1. 保存面板基本信息，回写面板 id
                const panelId = await this.savePanel(item, index);
                // 2. 保存默认状态值
                await this.syncStateItems(panelId, item.statusOptions);
                // 3. 刷新列表，保证前后端一致
                await this.loadStatusList();
            } catch (err) {
                list.splice(index, 1);
                this.$Message.error((err && err.msg) || "新增失败");
            }
        },
        // 删除状态面板项：有 id 时调 template_diy_state_del 删除整个面板，无 id 仅本地移除
        delStatus(index) {
            const list = this.newFormData.content.statusList;
            if (list.length <= 1) {
                this.$Message.warning("至少保留一个状态项");
                return;
            }
            const item = list[index];
            if (!item.id) {
                list.splice(index, 1);
                return;
            }
            template_diy_state_del({ id: item.id })
                .then(() => {
                    list.splice(index, 1);
                    // 删除后从 index 开始重排（后续项前移）
                    this.updateStatusSort(index);
                    // 删除后刷新列表
                    this.loadStatusList();
                    this.$Message.success("删除成功");
                })
                .catch((err) => {
                    this.$Message.error(err.msg || "删除失败");
                });
        },
        // 上移/下移状态面板项：交换后只对被移动的项调排序接口
        moveStatus(index, step) {
            const list = this.newFormData.content.statusList;
            const target = index + step;
            if (target < 0 || target >= list.length) return;
            const temp = list[index];
            this.$set(list, index, list[target]);
            this.$set(list, target, temp);
            // 被移动项 = 原 index 项（现位于 target 位置），只对这一项调 state_sort
            this.sortStatusItem(list[target], target);
        },
        getRulesCount(item) {
            return normalizeRules(item && item.rules).length;
        },
        // 回写状态面板保存结果中的面板 id
        applySaveResult(item, res) {
            const data = res && res.data ? res.data : {};
            if (data.id) {
                item.id = data.id;
            }
        },
        // 保存状态面板基本信息（state_save），成功后回写面板 id
        // 返回值：面板 id（新增时由后端返回）
        async savePanel(item, index) {
            if (!this.content_id || !this.newFormData.key) {
                return item.id || 0;
            }
            const res = await template_diy_state_save(
                this.buildPanelParams(item, index)
            );
            this.applySaveResult(item, res);
            return item.id || 0;
        },
        // 按索引持久化单个状态面板基本信息（权限修改后调用）
        async persistStatusItem(index, successMsg) {
            const list = this.newFormData.content.statusList || [];
            const item = list[index];
            if (!item) return;
            try {
                await this.savePanel(item, index);
                if (successMsg) {
                    this.$Message.success(successMsg);
                }
                await this.loadStatusList();
            } catch (err) {
                this.$Message.error((err && err.msg) || "保存失败");
            }
        },
        // —— 状态值（state_item）独立保存 ——
        // 保存单个状态值：id=0 新增，id>0 编辑；返回保存后的状态值（含后端 id）
        async saveStateItem(panelId, opt, sort) {
            const res = await template_diy_state_item_save({
                state_panel_id: panelId,
                id: opt.id || 0,
                name: opt.name,
                color: opt.color || getDefaultStatusColor(opt.name),
                is_default: opt.is_default == null ? 0 : Number(opt.is_default),
                switch_type: opt.switch_type == null ? 0 : Number(opt.switch_type),
                switch_support_types: normalizeSupportTypes(
                    opt.switch_support_types
                ),
                switch_is_required:
                    opt.switch_is_required == null
                        ? 1
                        : Number(opt.switch_is_required),
                sort: sort != null ? sort : opt.sort || 0,
            });
            const data = (res && res.data) || {};
            if (data.id) {
                opt.id = data.id;
            }
            return opt;
        },
        // 删除单个状态值（返回值非 code=200 时视为失败并抛错）
        async delStateItem(optId) {
            if (!optId) return;
            const res = await template_diy_state_item_del({ id: optId });
            if (!res || (res.code && Number(res.code) !== 200)) {
                throw res || { msg: "删除失败" };
            }
        },
        // 保存状态值列表（新增/编辑）：删除已在 delOption 中即时处理
        async syncStateItems(panelId, newOptions) {
            if (!panelId) return;
            for (let i = 0; i < newOptions.length; i++) {
                await this.saveStateItem(panelId, newOptions[i], i);
            }
        },
        // —— 变幻规则（rule）独立保存 ——
        // 保存单个规则：id=0 新增，id>0 编辑；返回保存后的规则（含后端 id）
        async saveRule(panelId, rule) {
            const res = await template_diy_rule_save({
                state_panel_id: panelId,
                id: rule.id || 0,
                form_id: rule.form_id,
                target_state_id: rule.target_state_id || 0,
            });
            const data = (res && res.data) || {};
            if (data.id) {
                rule.id = data.id;
            }
            return rule;
        },
        // 删除单个规则（返回值非 code=200 时视为失败并抛错）
        async delRuleItem(ruleId) {
            if (!ruleId) return;
            const res = await template_diy_rule_del({ id: ruleId });
            if (!res || (res.code && Number(res.code) !== 200)) {
                throw res || { msg: "删除失败" };
            }
        },
        // 保存规则列表（新增/编辑）：删除已在 delRule 中即时处理
        async syncRules(panelId, newRules) {
            if (!panelId) return;
            for (const rule of newRules) {
                await this.saveRule(panelId, rule);
            }
        },
        permissionText(who_type) {
            if (who_type == 0) return "所有人";
            if (who_type == 2) return "指定成员";
            return "全部成员";
        },
        requireText(opt) {
            if (!opt || opt.switch_type == 0) return "无任何要求";
            return "需填写描述信息";
        },
        // —— 编辑状态项 ——
        openStatusEdit(index) {
            this.ensureStatusList();
            this.ensureComponentKey();
            this.editIndex = index;
            const item = this.newFormData.content.statusList[index];
            this.editTitle = item.title || "";
            this.editOptions = JSON.parse(
                JSON.stringify(item.statusOptions || createDefaultOptions())
            ).map((opt) => ({
                ...opt,
                color: opt.color || getDefaultStatusColor(opt.name),
                state_key: opt.state_key || generateStateKey(),
            }));
            this.statusModal = true;
        },
        setDefaultOption(oi, checked) {
            this.editOptions.forEach((opt, i) => {
                opt.is_default = i === oi ? (checked ? 1 : 0) : 0;
            });
        },
        addOption() {
            this.editOptions.push({
                id: 0,
                state_key: generateStateKey(),
                name: "正常",
                color: getDefaultStatusColor("正常"),
                is_default: 0,
                switch_type: 0,
                switch_support_types: [1, 2, 3],
                switch_is_required: 1,
                sort: this.editOptions.length,
            });
        },
        async delOption(oi) {
            if (this.editOptions.length <= 1) {
                this.$Message.warning("至少保留一个状态项");
                return;
            }
            const opt = this.editOptions[oi];
            // 已保存过的状态值（有后端 id）先调删除接口，成功后再本地移除；失败则不删
            if (opt && opt.id) {
                try {
                    await this.delStateItem(opt.id);
                } catch (err) {
                    this.$Message.error((err && err.msg) || "删除失败");
                    return;
                }
                // 删除成功后同步移除面板已保存的状态值列表
                const item = this.newFormData.content.statusList[this.editIndex];
                if (item && Array.isArray(item.statusOptions)) {
                    const idx = item.statusOptions.findIndex(
                        (o) => o.id === opt.id
                    );
                    if (idx >= 0) item.statusOptions.splice(idx, 1);
                }
            }
            const wasDefault = opt && opt.is_default;
            this.editOptions.splice(oi, 1);
            if (wasDefault && this.editOptions.length) {
                this.editOptions[0].is_default = 1;
            }
        },
        // 保存「状态」编辑弹窗：
        // 1. 保存面板标题（state_save），确保拿到面板 id
        // 2. 对比新旧状态值，分别调 state_item_save / state_item_del 保存
        async saveStatusEdit() {
            if (!this.editTitle.trim()) {
                this.$Message.warning("请输入状态名");
                return;
            }
            if (!this.editOptions.length) {
                this.$Message.warning("请至少添加一个状态项");
                return;
            }
            const item = this.newFormData.content.statusList[this.editIndex];
            if (!item) return;
            item.title = this.editTitle.trim();
            const newOptions = JSON.parse(JSON.stringify(this.editOptions));
            try {
                // 1. 保存面板基本信息，确保拿到面板 id（新增面板时为 0）
                await this.savePanel(item, this.editIndex);
                const panelId = item.id;
                if (!panelId) {
                    this.$Message.error("状态面板保存失败，无法保存状态值");
                    return;
                }
                // 2. 同步状态值（新增/编辑）
                await this.syncStateItems(panelId, newOptions);
                // 3. 更新本地状态值列表与当前状态
                item.statusOptions = newOptions;
                const names = item.statusOptions.map((o) => o.name);
                if (!names.includes(item.current_status)) {
                    const def = item.statusOptions.find(
                        (o) => o.is_default == 1
                    );
                    item.current_status = (def && def.name) || names[0];
                }
                // 4. 刷新列表，保证前后端一致
                await this.loadStatusList();
                this.statusModal = false;
                this.$Message.success("保存成功");
            } catch (err) {
                this.$Message.error((err && err.msg) || "保存失败");
            }
        },
        // —— 切换要求 ——
        openRequire(oi) {
            const opt = this.editOptions[oi];
            this.requireIndex = oi;
            this.requireForm = {
                switch_type: opt.switch_type == null ? 0 : Number(opt.switch_type),
                switch_support_types: normalizeSupportTypes(
                    opt.switch_support_types
                ),
                switch_is_required:
                    opt.switch_is_required == null
                        ? 1
                        : Number(opt.switch_is_required),
            };
            this.requireModal = true;
        },
        saveRequire() {
            const opt = this.editOptions[this.requireIndex];
            opt.switch_type = Number(this.requireForm.switch_type);
            opt.switch_support_types = normalizeSupportTypes(
                this.requireForm.switch_support_types
            );
            opt.switch_is_required = Number(this.requireForm.switch_is_required);
            this.requireModal = false;
        },
        // —— 更新权限 ——
        // 打开「更新权限」弹窗，回显当前面板的 who_type/customer_ids
        openPermission(index) {
            this.ensureStatusList();
            this.editIndex = index;
            const item = this.newFormData.content.statusList[index];
            this.permissionForm = {
                who_type: item.who_type != null ? String(item.who_type) : "0",
                customer_ids: Array.isArray(item.customer_ids)
                    ? [...item.customer_ids]
                    : [],
            };
            if (!this.memberOptions.length) {
                this.getMemberList();
            }
            this.permissionModal = true;
        },
        // 保存权限：写回 item.who_type/customer_ids 后持久化
        savePermission() {
            const item = this.newFormData.content.statusList[this.editIndex];
            this.$set(item, "who_type", Number(this.permissionForm.who_type));
            this.$set(item, "customer_ids", [
                ...this.permissionForm.customer_ids,
            ]);
            this.persistStatusItem(this.editIndex, "权限保存成功").then(() => {
                this.permissionModal = false;
            });
        },
        // —— 自动变更规则 ——
        // 打开「自动变更规则」弹窗，回显规则列表并加载表单下拉
        openRules(index) {
            this.ensureStatusList();
            this.editIndex = index;
            const item = this.newFormData.content.statusList[index];
            this.editRules = JSON.parse(
                JSON.stringify(normalizeRules(item.rules))
            );
            this.loadFormOptions();
            this.rulesModal = true;
        },
        // 保存规则列表：对比新旧规则，分别调 rule_save / rule_del 持久化
        async saveRules() {
            const item = this.newFormData.content.statusList[this.editIndex];
            if (!item) return;
            const newRules = JSON.parse(
                JSON.stringify(normalizeRules(this.editRules))
            );
            try {
                // 确保面板 id 存在（规则必须挂在已保存的面板下）
                await this.savePanel(item, this.editIndex);
                const panelId = item.id;
                if (!panelId) {
                    this.$Message.error("状态面板保存失败，无法保存规则");
                    return;
                }
                await this.syncRules(panelId, newRules);
                this.$set(item, "rules", newRules);
                this.rulesModal = false;
                this.$Message.success("规则保存成功");
            } catch (err) {
                this.$Message.error((err && err.msg) || "规则保存失败");
            }
        },
        // 删除单条规则：先调删除接口，成功后再本地移除；失败则不删
        async delRule(ri) {
            const rule = this.editRules[ri];
            if (rule && rule.id) {
                try {
                    await this.delRuleItem(rule.id);
                } catch (err) {
                    this.$Message.error((err && err.msg) || "删除失败");
                    return;
                }
                // 删除成功后同步移除面板已保存的规则列表
                const item = this.newFormData.content.statusList[this.editIndex];
                if (item && Array.isArray(item.rules)) {
                    const idx = item.rules.findIndex(
                        (r) => r.id === rule.id
                    );
                    if (idx >= 0) item.rules.splice(idx, 1);
                }
            }
            this.editRules.splice(ri, 1);
        },
        // 打开新增/编辑单条规则的弹窗（ri === -1 为新增）
        openRuleForm(ri) {
            this.ruleEditIndex = ri;
            if (ri === -1) {
                this.ruleForm = {
                    form_id: "",
                    form_name: "",
                    target_state_key: "",
                };
            } else {
                const rule = this.editRules[ri];
                // 回填 target_state_key：优先规则里的 key，否则按 target_state_id 反查状态值的 key
                let targetStateKey = rule.target_state_key || "";
                if (!targetStateKey && rule.target_state_id) {
                    const opt = this.currentStatusOptions.find(
                        (o) => o.id === Number(rule.target_state_id)
                    );
                    if (opt) targetStateKey = opt.state_key;
                }
                this.ruleForm = {
                    form_id: rule.form_id,
                    form_name: rule.form_name,
                    target_state_key: targetStateKey,
                };
            }
            this.ruleFormModal = true;
            this.loadFormOptions();
        },
        // 选择表单后回填表单名称（用于规则列表展示）
        onFormChange(id) {
            const form = this.formOptions.find((f) => f.id == id);
            this.ruleForm.form_name = form ? form.name : "";
        },
        // 保存单条规则：通过 state_key 找到目标状态值，写入 target_state_id/target_state_key
        saveRuleForm() {
            if (!this.ruleForm.form_id) {
                this.$Message.warning("请选择表单");
                return;
            }
            if (!this.ruleForm.target_state_key) {
                this.$Message.warning("请选择状态项");
                return;
            }
            const target = this.currentStatusOptions.find(
                (o) => o.state_key === this.ruleForm.target_state_key
            );
            const data = {
                id:
                    this.ruleEditIndex >= 0 &&
                    this.editRules[this.ruleEditIndex]
                        ? this.editRules[this.ruleEditIndex].id || 0
                        : 0,
                form_id: this.ruleForm.form_id,
                form_name: this.ruleForm.form_name,
                target_state_id: target ? target.id || 0 : 0,
                target_state_key: this.ruleForm.target_state_key,
            };
            if (this.ruleEditIndex === -1) {
                this.editRules.push(data);
            } else {
                this.$set(this.editRules, this.ruleEditIndex, data);
            }
            this.ruleFormModal = false;
        },
        // 根据 form_id 从表单下拉中回显表单名称（规则列表展示用）
        formName(rule) {
            const form = this.formOptions.find((f) => f.id == rule.form_id);
            return (form && form.name) || rule.form_name || "表单名称";
        },
        // 根据 target_state_id（或 target_state_key）返回目标状态值名称（规则列表展示用）
        targetStatusName(rule) {
            const opt = this.currentStatusOptions.find(
                (o) =>
                    o.id === Number(rule.target_state_id) ||
                    (rule.target_state_key &&
                        o.state_key === rule.target_state_key)
            );
            return (opt && opt.name) || "状态";
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0 12px;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.section-label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
}
.status-list-box {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px;
    background: #fff;
}
.status-item {
    position: relative;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px 12px 4px;
    margin-bottom: 12px;
    background: #fafafa;
}
.item-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
}
.action-link {
    color: #ff761d;
    cursor: pointer;
    margin-left: 12px;
    font-size: 13px;
}
.ml8 {
    margin-left: 8px;
}
.ml12 {
    margin-left: 12px;
}
.mr12 {
    margin-right: 12px;
}
.mb8 {
    margin-bottom: 8px;
}
.mb12 {
    margin-bottom: 12px;
}
.mb16 {
    margin-bottom: 16px;
}
.mt12 {
    margin-top: 12px;
}
.mt16 {
    margin-top: 16px;
}
.del-btn {
    margin-left: 12px;
    width: 28px;
    height: 28px;
    background: #ff761d;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.add-status {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: #ff761d;
    cursor: pointer;
    font-size: 14px;
}
.add-status span {
    margin-left: 4px;
}
.style-select {
    gap: 16px;
    margin-bottom: 12px;
}
.style-card {
    flex: 1;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
    background: #fff;
}
.style-card-active {
    border-color: #ff761d;
    box-shadow: 0 0 0 1px #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.modal-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.modal-label {
    margin-right: 12px;
    white-space: nowrap;
    color: #484e66;
}
.opt-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
}
.opt-req {
    margin-left: auto;
    color: #666;
    font-size: 13px;
}
.w120 {
    width: 120px;
}
.w240 {
    width: 240px;
}
.cursor-p {
    cursor: pointer;
}
.require-box {
    margin: 12px 0 0 24px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
}
.perm-tip {
    margin: 4px 0 0 24px;
    color: #999;
    font-size: 12px;
}
.rules-empty {
    text-align: center;
    padding: 48px 24px 32px;
}
.empty-tip {
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
    color: #484e66;
    line-height: 1.5;
}
.empty-desc {
    max-width: 480px;
    margin: 0 auto 32px;
    color: #999;
    font-size: 13px;
    line-height: 1.8;
    text-align: center;
}
.empty-add-btn {
    min-width: 140px;
    height: 40px;
    font-size: 14px;
}
.rule-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 12px;
    margin-bottom: 8px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #fafafa;
}
.rule-text {
    flex: 1;
    color: #484e66;
    font-size: 13px;
    line-height: 1.6;
    padding-right: 12px;
}
.rule-actions {
    white-space: nowrap;
}
.w1 {
    width: 100%;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #ff761d;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
::v-deep .ivu-menu-horizontal .ivu-menu-item-active,
::v-deep .ivu-menu-horizontal .ivu-menu-item:hover,
::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
    color: #ff761d;
    border-bottom-color: #ff761d;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.flex-box {
    display: flex;
    align-items: center;
}
</style>